import { render, staticRenderFns } from "./EditCriminalConvictionsDialog.vue?vue&type=template&id=47910e44&"
import script from "./EditCriminalConvictionsDialog.vue?vue&type=script&lang=js&"
export * from "./EditCriminalConvictionsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports